import Text from 'components/ui/text'
import { translate } from 'utils/translation'

export const LoadingText = () => {
  return (
    <Text
      className="tw-text-[#636363] tw-text-sm tw-m-4 tw-font-normal tw-font-['Geomanist'] tw-leading-none"
      boldClassName="tw-text-[#636363] tw-text-sm tw-font-normal tw-font-['Geomanist'] tw-leading-none"
    >
      {translate('loading_messaging')}
    </Text>
  )
}
